import { Component, ElementRef, OnInit, Input } from '@angular/core';
import { ImageService } from '@utils/services/image/image.service';
import {Functionary} from '@core/services/functionary';

@Component({
  selector: 'app-functionary-card',
  templateUrl: './functionary-card.component.html',
  styleUrls: ['./functionary-card.component.scss']
})
export class FunctionaryCardComponent implements OnInit {
  @Input() person: Functionary;
  @Input() styleMode; // either standalone or list-item
  @Input() functionMode; // either player, trainer or functionary

  constructor(
    private elementRef: ElementRef,
  ) { }

  ngOnInit() {
  }

  getFunctionsList(): string {
    let list = '';
    this.person.functions.forEach(func => {
      list += func.getNameOfFunction(false) + ', ';
    })

    return list.slice(0, -2);
  }
}
